#import "../fragments/source-fragment.graphql"

mutation CreateSource($source: SourceCreateInput!) {
    sourceCreate(input: $source) {
        source {
            ...SourceFragment
        }
    }
}
